"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackerButton = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
const colors_1 = require("../utils/colors");
// eslint-disable-next-line react/display-name
exports.HackerButton = react_2.default.forwardRef((_a, ref) => {
    var { filled, colorHex } = _a, props = __rest(_a, ["filled", "colorHex"]);
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    const color = colorHex !== null && colorHex !== void 0 ? colorHex : primaryColor;
    return (react_2.default.createElement(react_1.Button, Object.assign({ ref: ref, variant: "outline", colorScheme: color, borderRadius: 0, fontWeight: "thin", borderColor: color, bgColor: filled ? color : undefined, color: filled ? 'black' : color, _focus: { outline: 0 }, _hover: {
            bgColor: filled ? (0, colors_1.alphaColor)(color, 0.7) : (0, colors_1.alphaColor)(color, 0.1),
        }, _active: {
            bgColor: filled ? (0, colors_1.alphaColor)(color, 0.9) : (0, colors_1.alphaColor)(color, 0.2),
        } }, props)));
});
//# sourceMappingURL=HackerButton.js.map